import { render, staticRenderFns } from "./StudentMarvelousBio.vue?vue&type=template&id=33c1ddc2&scoped=true&"
import script from "./StudentMarvelousBio.vue?vue&type=script&lang=ts&"
export * from "./StudentMarvelousBio.vue?vue&type=script&lang=ts&"
import style0 from "./StudentMarvelousBio.vue?vue&type=style&index=0&id=33c1ddc2&lang=scss&scoped=true&"
import style1 from "./StudentMarvelousBio.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1ddc2",
  null
  
)

export default component.exports